module.exports = "/_next/static/files/2e42e06de0306403502821e0f8c2c26c.png";